import type { FilterOption } from '../types';

function valuesForOption(option: FilterOption): string[] {
  const merged = option.metadata?.mergedValues;
  if (
    Array.isArray(merged) &&
    merged.every((item): item is string => typeof item === 'string')
  ) {
    return merged;
  }
  return [option.value];
}

/**
 * One option per display label. Colliding options keep every raw id on
 * `metadata.mergedValues` so a single choice selects all of them.
 * The first option for a label survives; later ones fold into it.
 */
export function collapseOptionsByLabel(
  options: FilterOption[]
): FilterOption[] {
  const labelMap = new Map<string, FilterOption>();
  const deduped: FilterOption[] = [];
  for (const option of options) {
    const key = option.label ?? option.value;
    const existing = labelMap.get(key);
    if (existing) {
      const merged = [
        ...new Set([...valuesForOption(existing), ...valuesForOption(option)]),
      ];
      existing.metadata = { ...existing.metadata, mergedValues: merged };
    } else {
      labelMap.set(key, option);
      deduped.push(option);
    }
  }
  return deduped;
}
